import { Col, Collapse, Row } from "antd";
import React from "react";

import style from "./IndexList.module.css";

type IndexItemProps = {
  name: string;
  onAdd: (content: string) => void;
};

const IndexItem: React.FC<IndexItemProps> = ({ name, onAdd }) => {
  return (
    <Row style={{ width: "100%" }}>
      <Col span={24}>
        <div className={style.item} onClick={() => onAdd(name)}>
          <span>{name}</span>+
        </div>
      </Col>
    </Row>
  );
};

type IndexListProps = {
  list: Array<{
    name: string;
    children: {
      name: string;
    }[];
  }>;
  onAdd: (content: string) => void;
};

const IndexList: React.FC<IndexListProps> = ({ list, onAdd }) => {
  return (
    <Row className={style.list}>
      <Col span={24} style={{ paddingTop: "-14px" }}>
        <Collapse>
          {list.map((item) => {
            return (
              <Collapse.Panel header={item.name} key={item.name}>
                {item.children.map((ch) => (
                  <IndexItem
                    name={ch.name}
                    onAdd={onAdd}
                    key={ch.name}
                  ></IndexItem>
                ))}
              </Collapse.Panel>
            );
          })}
        </Collapse>
      </Col>
    </Row>
  );
};

export default IndexList;
